import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import InventoryProvider from "./context/GlobalContext";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  // <React.StrictMode>
  <InventoryProvider>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </InventoryProvider>
  // {/* </React.StrictMode> */}
);
